import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import styled from 'styled-components'

export const Layout = styled.div`
  margin: 0 auto;

  @media ${DEVICES.tablet} {
    display: block;
  }
`

export const Main = styled.main`
  position: relative;
  z-index: 2;
  background-color: ${COLORS.white};

  @media ${DEVICES.tablet} {
    padding-left: 0;
    width: 100%;
  }
`
